import useToastContext from '@contexts/ToastContext/hook';
import { PropsWithChildren, createContext, useEffect, useState } from 'react';
import { GetInvalidPixKeyResponse } from '@interfaces/profile';
import { getPlatformUserInvalidPixKeys } from '@api/profile';
import { InvalidPixKeyModal } from '@components/Profile/InvalidPixKeyModal/InvalidPixKeyModal';

export const ProfileContext = createContext({});

type Props = PropsWithChildren;

export const ProfileContextProvider = (props: Props) => {
  const [invalidPixKeys, setInvalidPixKeys] = useState<
    GetInvalidPixKeyResponse[]
  >([]);
  const toast = useToastContext();
  const fetchInvalidPixKeys = async () => {
    try {
      const response = await getPlatformUserInvalidPixKeys();
      setInvalidPixKeys(response);
    } catch (err: any) {
      toast.setContent(
        err.detail || 'Ocorreu um erro ao buscar as chaves pix do usuário.',
      );
    }
  };
  useEffect(() => {
    fetchInvalidPixKeys();
  }, []);

  return (
    <ProfileContext.Provider value={{}}>
      <InvalidPixKeyModal invalidPixKeys={invalidPixKeys} />
      {props.children}
    </ProfileContext.Provider>
  );
};
